import { AbstractDisplayComponent } from "./AbstractDisplayComponet";

export interface IComponentFactory {
    initialize(): AbstractDisplayComponent;
}

export class DisplayComponentFactory<T extends new (...args: Array<unknown>) => AbstractDisplayComponent> implements IComponentFactory {
    protected type: T;
    protected args: ConstructorParameters<T>;

    constructor(type: T, ...args: ConstructorParameters<T>) {
        this.type = type;
        this.args = args;
    }

    public initialize(): AbstractDisplayComponent {
        return new this.type(...this.args);
    }
}
